import { useEffect } from "react";
import { HashRouter, Routes, Route, useLocation } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { ROUTE_PATHS } from "@/lib/index";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import ServicesIndividual from "@/pages/ServicesIndividual";
import ServicesBusiness from "@/pages/ServicesBusiness";
import Reviews from "@/pages/Reviews";
import Gallery from "@/pages/Gallery";
import Publications from "@/pages/Publications";
import Contact from "@/pages/Contact";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1,
    },
  },
});

function ScrollToTop(): null {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    } as ScrollToOptions);
  }, [pathname]);

  return null;
}

function App(): JSX.Element {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner position="top-right" />
        <HashRouter>
          <ScrollToTop />
          <Layout>
            <Routes>
              <Route path={ROUTE_PATHS.HOME} element={<Home />} />
              <Route path={ROUTE_PATHS.ABOUT} element={<About />} />
              <Route path={ROUTE_PATHS.SERVICES} element={<Services />} />
              <Route path={ROUTE_PATHS.SERVICES_INDIVIDUAL} element={<ServicesIndividual />} />
              <Route path={ROUTE_PATHS.SERVICES_BUSINESS} element={<ServicesBusiness />} />
              <Route path={ROUTE_PATHS.REVIEWS} element={<Reviews />} />
              <Route path={ROUTE_PATHS.GALLERY} element={<Gallery />} />
              <Route
                path={ROUTE_PATHS.PUBLICATIONS}
                element={<Publications />}
              />
              <Route path={ROUTE_PATHS.CONTACT} element={<Contact />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </Layout>
        </HashRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;